<div class="order-detail-page">
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los pedidos</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <div *ngIf="loaded && loadError" class="empty-state">
        <i class="fal fa-circle-exclamation"></i>
        <p>No hemos podido cargar el pedido</p>
        <span>Puede que ya no exista o que no pertenezca a esta compañía</span>
    </div>

    <ng-container *ngIf="loaded && !loadError && order">
        <!-- Cabecera: ticket, importe y estado -->
        <div class="order-hero">
            <div class="hero-main">
                <div class="hero-ticket">
                    <span class="hero-label">Nº de ticket</span>
                    <p class="hero-ticket-value" *ngIf="order.num_ticket">{{ order.num_ticket }}</p>
                    <p class="hero-ticket-value hero-ticket-value--empty" *ngIf="!order.num_ticket">Sin emitir</p>
                    <span class="hero-hint" *ngIf="!order.num_ticket">El TPV solo emite ticket cuando el cobro se completa</span>
                </div>

                <div class="hero-amount">
                    <span class="hero-label">{{ isPaid ? 'Importe pagado' : 'Importe' }}</span>
                    <p class="hero-amount-value">{{ order.total | number: '1.2-2' }} €</p>
                </div>

                <span class="status-badge" [ngClass]="statusBadgeClass">
                    <i class="fa-solid" [ngClass]="statusIcon"></i>
                    {{ order.status?.name || 'Sin estado' }}
                </span>
            </div>

            <div class="hero-meta">
                <div class="meta-item">
                    <span class="meta-label">Pedido</span>
                    <p class="meta-value">#{{ order.id }}</p>
                </div>
                <div class="meta-item">
                    <span class="meta-label">Fecha</span>
                    <p class="meta-value">{{ order.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
                </div>
                <div class="meta-item">
                    <span class="meta-label">Canal</span>
                    <p class="meta-value"><i class="fal" [ngClass]="channelIcon"></i> {{ channelLabel }}</p>
                </div>
                <div class="meta-item" *ngIf="order.id_invoicing">
                    <span class="meta-label">ID de transacción</span>
                    <p class="meta-value">{{ order.id_invoicing }}</p>
                </div>
            </div>
        </div>

        <div class="detail-layout">
            <div class="detail-column">
                <!-- Desglose económico -->
                <div class="detail-card">
                    <div class="card-header">
                        <i class="fal fa-receipt card-icon"></i>
                        <div>
                            <h2>Desglose</h2>
                            <p class="card-subtitle">Qué se ha cobrado en este pedido</p>
                        </div>
                    </div>

                    <div class="line-item">
                        <div class="line-info">
                            <p class="line-name">{{ order.product?.name || 'Producto no disponible' }}</p>
                            <span class="line-detail">{{ order.price | number: '1.2-2' }} € × {{ order.quantity }}</span>
                        </div>
                        <p class="line-amount">{{ subtotal | number: '1.2-2' }} €</p>
                    </div>

                    <div class="line-item" *ngIf="feeAmount > 0">
                        <div class="line-info">
                            <p class="line-name">Gastos de gestión</p>
                            <span class="line-detail">Aplicados por el TPV</span>
                        </div>
                        <p class="line-amount">{{ feeAmount | number: '1.2-2' }} €</p>
                    </div>

                    <div class="line-total">
                        <p class="line-name">Total</p>
                        <p class="line-amount">{{ order.total | number: '1.2-2' }} €</p>
                    </div>
                </div>

                <!-- Abono al que corresponde el cobro -->
                <div class="detail-card" *ngIf="order.season_pass">
                    <div class="card-header">
                        <i class="fal fa-id-card card-icon"></i>
                        <div>
                            <h2>Abono</h2>
                            <p class="card-subtitle">El abono que este pedido activa o renueva</p>
                        </div>
                    </div>

                    <div class="data-grid">
                        <div class="data-item">
                            <span class="meta-label">Abonado</span>
                            <p class="meta-value">{{ order.season_pass.user?.name || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">NIF</span>
                            <p class="meta-value">{{ order.season_pass.user?.nif || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">Email</span>
                            <p class="meta-value">{{ order.season_pass.user?.email || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">Temporada</span>
                            <p class="meta-value">{{ order.season_pass.season?.name || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">Nº de abonado</span>
                            <p class="meta-value">{{ order.season_pass.member_number || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">Categoría</span>
                            <p class="meta-value">{{ order.season_pass.category?.name || '—' }}</p>
                        </div>
                        <!-- "Ubicación": el valor lleva el nivel delante de la fila
                             y la butaca, que sin él no identifican ningún sitio. -->
                        <div class="data-item">
                            <span class="meta-label">Ubicación</span>
                            <p class="meta-value">{{ seatDisplay || '—' }}</p>
                        </div>
                        <div class="data-item">
                            <span class="meta-label">Estado del abono</span>
                            <p class="meta-value">{{ order.season_pass.status?.name || '—' }}</p>
                        </div>
                    </div>

                    <button type="button" class="btn-link" (click)="goToPass()">
                        <i class="fal fa-arrow-up-right-from-square"></i> Ver ficha del abono
                    </button>
                </div>
            </div>

            <div class="detail-column detail-column--side">
                <div class="detail-card">
                    <div class="card-header">
                        <i class="fal fa-circle-info card-icon"></i>
                        <div>
                            <h2>Registro</h2>
                            <p class="card-subtitle">Quién y cuándo</p>
                        </div>
                    </div>

                    <div class="side-item">
                        <span class="meta-label">Creado</span>
                        <p class="meta-value">{{ order.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
                    </div>
                    <div class="side-item">
                        <span class="meta-label">Última actualización</span>
                        <p class="meta-value">{{ order.updated_at | date:'dd/MM/yyyy HH:mm' }}</p>
                    </div>
                    <div class="side-item" *ngIf="order.creator">
                        <span class="meta-label">Cobrado por</span>
                        <p class="meta-value">{{ order.creator.name }}</p>
                    </div>
                    <div class="side-item" *ngIf="!order.creator">
                        <span class="meta-label">Origen</span>
                        <p class="meta-value">Pago online del abonado</p>
                    </div>

                    <span class="field-hint" *ngIf="!isPaid">
                        <i class="fal fa-info-circle"></i> Mientras el pedido no esté pagado, el abono sigue pendiente. El estado se sincroniza con el TPV.
                    </span>
                </div>
            </div>
        </div>
    </ng-container>
</div>
